import { Avatar, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ContactUsHeadphones } from 'Images';

export const ContactUsSegment = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const isDesktop = useIsDesktop();
  return isDesktop ? (
    <Stack
      justifyContent={'center'}
      flexDirection={'row'}
      alignItems={'center'}
    >
      <Avatar
        src={ContactUsHeadphones}
        sx={{ width: '32px', height: '32px', mr: 1 }}
        alt=''
      />
      <Typography variant='body3' display={'inline'}>
        {dictionary.forQuestionsContactTheHotlineOnTheWebsiteOrByPhone[0]}
      </Typography>
    </Stack>
  ) : (
    <Stack
      sx={{
        p: '16px',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Avatar
        src={ContactUsHeadphones}
        sx={{ width: '35px', height: '35px', mr: 1 }}
        alt=''
      />
      <Stack>
        <Typography variant='body3' display={'inline'}>
          {dictionary.forQuestionsContactTheHotlineOnTheWebsiteOrByPhone[4]}
          <Link
            variant='body2'
            underline='none'
            href={`tel:${dictionary.forQuestionsContactTheHotlineOnTheWebsiteOrByPhone[2]}`}
          >
            <Typography variant='body3' display={'inline'} ml={'5px'}>
              {dictionary.forQuestionsContactTheHotlineOnTheWebsiteOrByPhone[3]}
            </Typography>
          </Link>
        </Typography>
      </Stack>
    </Stack>
  );
};
